import { render, staticRenderFns } from "./yxxTable.vue?vue&type=template&id=1e93bc98&scoped=true"
import script from "./yxxTable.vue?vue&type=script&lang=ts"
export * from "./yxxTable.vue?vue&type=script&lang=ts"
import style0 from "./yxxTable.vue?vue&type=style&index=0&id=1e93bc98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e93bc98",
  null
  
)

export default component.exports